import { Loader2, Briefcase } from "lucide-react";
import StaffListRow from "./Row";

const StaffList = ({ staff, loading, onDelete, onEdit }) => {
  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <Loader2 className="w-10 h-10 text-purple-500 animate-spin mb-3" />
        <p className="text-slate-500 text-sm">در حال بارگذاری کارکنان...</p>
      </div>
    );
  }

  if (!staff || staff.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-4">
          <Briefcase className="w-8 h-8 text-slate-400" />
        </div>
        <p className="text-slate-600 font-medium mb-1">هیچ کارمندی یافت نشد</p>
        <p className="text-slate-400 text-sm">
          برای شروع، یک کارمند جدید اضافه کنید
        </p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto px-3">
      <div className="inline-block min-w-full align-middle">
        <div className="overflow-hidden">
          <table className="min-w-full divide-y divide-slate-200">
            <thead>
              <tr className="bg-slate-50/50">
                <th className="text-right px-3 sm:px-6 py-3 sm:py-4 text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">
                  نام کامل
                </th>
                <th className="hidden md:table-cell text-right px-3 sm:px-6 py-3 sm:py-4 text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">
                  شماره تماس
                </th>
                <th className="hidden lg:table-cell text-right px-3 sm:px-6 py-3 sm:py-4 text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">
                  خدمات
                </th>
                <th className="text-left px-3 sm:px-6 py-3 sm:py-4 text-xs font-semibold text-slate-600 uppercase tracking-wider whitespace-nowrap">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-100">
              {staff.map((item) => (
                <StaffListRow
                  key={item._id}
                  item={item}
                  onDelete={onDelete}
                  onEdit={onEdit}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StaffList;